import { AnyAction } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  RoleDeterminedPayload,
} from '@ps20-frontend/shop-integration-redux';
import { Role } from '@ps20/bff-models';
import { INITIAL_STATE } from '../initialState';

export const roleReducer = function (role: Role = INITIAL_STATE.role, action: AnyAction): Role {
  switch (action.type) {
    case GlobalActions.ROLE_DETERMINED: {
      const globalAction: GlobalAction<RoleDeterminedPayload> = action;
      return globalAction.payload.role;
    }
    default:
      return role;
  }
};
